<script>
  import { onMount } from "svelte";
  import { items } from "./stores.js";
  import { fade } from "svelte/transition";

  export let businessCode;
  export let checkoutUrl;

  onMount(async () => {
    await items.checkoutProducts(businessCode);
  });

  $: products = $items.checkoutProducts;

  const DEFAULT_IMAGE_PATH = "/static/images/tab-worldmap-small.jpg";
</script>

<div class="row">
  {#each products as product}
    <div
      in:fade={{ delay: product ? 0 : delay + i * 100, duration: 1000 }}
      class="col-6 col-md-4">
      <div
        class="card rounded-lg text-white border-0 shadow overflow-hidden hover-scale"
        role="button">
        <div class="dark-overlay embed-responsive embed-responsive-4by3">
          {#if product.imageGallery}
            <img
              class="card-img embed-responsive-item"
              src={product.imageGallery + "/nth/0/" + "-/quality/lightest/"}
              data-blink-quality="lightest"
              data-blink-scale-crop="450x300"
              data-blink-scale-crop-position="smart"
              alt={product.name} />
          {:else}
            <img
              class="card-img embed-responsive-item test"
              src={DEFAULT_IMAGE_PATH}
              alt={product.name} />
          {/if}
          <a
            href={checkoutUrl + "/product/" + product?.businessSpecificId}
            target="_blank"
            rel="noopener noreferrer">
            <div class="card-img-overlay d-flex align-items-start z-index-20 p-2 p-md-4">
              <!-- Align to the top of the card -->
              <span
                class="h5 card-title font-weight-normal text-truncate-4"
                style="color: white; text-decoration: none !important;">
                {product.name}
              </span>
            </div>
          </a>
        </div>
      </div>
    </div>
  {/each}
</div>
